import React, { useEffect, useRef, useState } from "react";
import LanguageIcon from "assets/Icons/LanguageIcon";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n"; // Import the initialized i18n instance

const LanguageSelector = () => {
  const dropdownRef = useRef(null);
  const { t } = useTranslation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState(
    localStorage.getItem("language") || "ar"
  );

  useEffect(() => {
    if (!localStorage.getItem("language")) {
      setCurrentLanguage("ar");
      i18n.changeLanguage("ar");
    }
  }, []);

  const toggleDropdown = () => setIsDropdownOpen((prev) => !prev);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLanguageChange = (newLanguage) => {
    i18n.changeLanguage(newLanguage);
    setCurrentLanguage(newLanguage);
    localStorage.setItem("language", newLanguage);
    document.documentElement.lang = newLanguage;
    document.documentElement.dir = newLanguage === "ar" ? "rtl" : "ltr";
    setIsDropdownOpen(false);
    localStorage.setItem("language", newLanguage)
    window.location.reload();
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <span
        onClick={toggleDropdown}
        className="flex items-center gap-2 cursor-pointer md:bg-[#e7edf2] rounded-[8px] px-[12px] py-[8px] focus:outline-none"
      >
        <span className="text-[14px] text-primary hidden md:flex text-[#0d6b70]">
          {currentLanguage === "ar" ? "العربية" : "English"}
        </span>
        <div className="language-icon w-[20px] h-[20px]">
          <LanguageIcon />
        </div>
      </span>

      {isDropdownOpen && (
        <div className="absolute start-0 mt-2 w-[120px] bg-white border border-gray-200 rounded shadow-md z-50">
          <ul className="flex flex-col">
            <li>
              <button
                onClick={() => handleLanguageChange("en")}
                className={`block w-full text-start px-4 py-2 hover:bg-[#e7edf2] ${
                  currentLanguage === "en" ? "font-bold text-[#0d6b70]" : ""
                }`}
              >
                English
              </button>
            </li>
            <li>
              <button
                onClick={() => handleLanguageChange("ar")}
                className={`block w-full text-start px-4 py-2 hover:bg-[#e7edf2] ${
                  currentLanguage === "ar" ? "font-bold text-[#0d6b70]" : ""
                }`}
              >
                العربية
              </button>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
